import React from 'react';
import { HeroHeading } from './components/HeroHeading/HeroHeading';
import { HeroDescription } from './components/HeroDescription/HeroDescription';
import { HeroCta } from './components/HeroCta/HeroCta';
import './HeroContent.css';

export function HeroContent() {
  return (
    <div className="hero-content">
      <HeroHeading />
      <HeroDescription />
      <HeroCta />
    </div>
  );
}
